/* =====================================================================
   STARTUS CLOUD — shared runtime (sc-common.js)
   Loaded `defer` from theme.liquid <head>. Page-level interactivity lives
   here via document-level DELEGATION (§5.3/§5.6) so it always runs, is
   isolated from the fragile per-section {% javascript %} bundle, and
   survives theme-editor re-renders (shopify:section:load).
   window.SC is the single namespace. Guard every lookup.
   ===================================================================== */
(function () {
  'use strict';
  var SC = (window.SC = window.SC || {});

  /* ── reveal-on-scroll (opt-in: add class `reveal`; adds `in` when visible) ── */
  SC.initReveal = function (root) {
    var scope = root || document;
    var els = scope.querySelectorAll('.sc .reveal:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  };

  /* ── tab groups (.tabs > .tab ; active = .tab-on) — pure UI toggle ──────── */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.sc .tabs .tab');
    if (!tab) return;
    var group = tab.closest('.tabs');
    group.querySelectorAll('.tab').forEach(function (x) {
      x.classList.remove('tab-on'); x.setAttribute('aria-selected', 'false');
    });
    tab.classList.add('tab-on'); tab.setAttribute('aria-selected', 'true');
    // reveal the matching panel if the tab targets one
    var target = tab.getAttribute('data-target');
    if (target) {
      var host = group.closest('[data-sc-tabs]') || document;
      host.querySelectorAll('[data-panel]').forEach(function (p) {
        p.classList.toggle('hide', p.getAttribute('data-panel') !== target);
      });
    }
  });

  /* ── countdown timers — <element data-sc-countdown-to="ISO-8601"> with
     three .cd-unit children (H, M, S). Real end date from a section setting;
     freezes at 00 when elapsed. ─────────────────────────────────────────── */
  SC.initCountdowns = function (root) {
    var scope = root || document;
    scope.querySelectorAll('[data-sc-countdown-to]').forEach(function (box) {
      if (box.__scCd) return; box.__scCd = true;
      var end = new Date(box.getAttribute('data-sc-countdown-to')).getTime();
      var units = box.querySelectorAll('.cd-unit');
      if (isNaN(end) || units.length < 3) return;
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var hideOnEnd = box.hasAttribute('data-sc-hide-on-end') || box.closest('[data-sc-hide-on-end]');
      var tick = function () {
        var d = Math.max(0, end - Date.now());
        var h = Math.floor(d / 3.6e6), m = Math.floor((d % 3.6e6) / 6e4), s = Math.floor((d % 6e4) / 1e3);
        if (units[0].childNodes[0]) units[0].childNodes[0].nodeValue = pad(h);
        if (units[1].childNodes[0]) units[1].childNodes[0].nodeValue = pad(m);
        if (units[2].childNodes[0]) units[2].childNodes[0].nodeValue = pad(s);
        if (d <= 0) {
          if (box.__scCdTimer) clearInterval(box.__scCdTimer);
          if (hideOnEnd) {
            var target = box.closest('.hero-deal') || box.closest('[data-sc-hide-on-end]');
            if (target) target.style.display = 'none';
          }
        }
      };
      tick(); box.__scCdTimer = setInterval(tick, 1000);
    });
  };

  /* ── WISHLIST — client-side, localStorage; document-delegated (§5.4) ───── */
  var WKEY = 'sc:wishlist';
  var wl = {
    all: function () {
      try {
        var raw = localStorage.getItem(WKEY) || localStorage.getItem('ks-wishlist');
        return JSON.parse(raw) || [];
      } catch (e) { return []; }
    },
    _save: function (a) {
      localStorage.setItem(WKEY, JSON.stringify(a));
      localStorage.setItem('ks-wishlist', JSON.stringify(a));
      document.dispatchEvent(new CustomEvent('sc:wishlist:change', { detail: a }));
    },
    has: function (id) {
      if (!id) return false;
      var sid = String(id);
      return this.all().some(function (i) {
        return (i.id && String(i.id) === sid) || 
               (i.url && String(i.url).indexOf(sid) > -1) || 
               (i.handle && sid.indexOf(i.handle) > -1);
      });
    },
    toggle: function (item) {
      var a = this.all();
      var id = String(item.id || item.url || '');
      var i = a.findIndex(function (x) {
        return (item.id && x.id && String(x.id) === String(item.id)) || 
               (item.url && x.url && String(x.url) === String(item.url)) ||
               (item.handle && x.handle && String(x.handle) === String(item.handle)) ||
               (x.url && id && String(x.url).indexOf(id) > -1);
      });
      if (i > -1) {
        a.splice(i, 1);
      } else {
        a.push(item);
      }
      this._save(a);
      return i === -1;
    },
    count: function () { return this.all().length; }
  };
  SC.wishlist = wl;

  function parseWishItem(el) {
    var raw = el.getAttribute('data-sc-wish-item') || el.getAttribute('data-product') || '';
    if (raw) {
      try {
        var txt = document.createElement('textarea');
        txt.innerHTML = raw;
        var parsed = JSON.parse(txt.value);
        if (parsed && typeof parsed === 'object') return parsed;
      } catch (err) {}
    }
    var card = el.closest('.card, .product-card, article');
    var linkEl = card ? card.querySelector('a[href*="/products/"]') : null;
    var url = el.getAttribute('data-sc-wish') || (linkEl ? linkEl.getAttribute('href') : window.location.pathname);
    var titleEl = card ? card.querySelector('.card-title, .product-title, h3, h2') : null;
    var title = titleEl ? titleEl.textContent.trim() : document.title;
    var imgEl = card ? card.querySelector('img') : null;
    var img = imgEl ? (imgEl.getAttribute('src') || imgEl.getAttribute('srcset')) : '';
    var priceEl = card ? card.querySelector('.price-now, .price') : null;
    var price = priceEl ? priceEl.textContent.trim() : '';

    return {
      id: el.getAttribute('data-sc-wish') || url,
      url: url || window.location.pathname,
      handle: url ? (url.split('/products/')[1] || '').split('?')[0] : '',
      title: title || 'Product',
      img_src: img || '',
      price: price || '',
      added_at: Date.now()
    };
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sc-wish], .card-wish');
    if (!t) return;
    e.preventDefault();
    var item = parseWishItem(t);
    var added = wl.toggle(item);
    t.classList.toggle('is-on', added);
    t.classList.toggle('active', added);
    t.setAttribute('aria-pressed', added ? 'true' : 'false');
  });

  SC.syncWishlistUI = function (root) {
    var scope = root || document;
    var items = wl.all();
    var count = items.length;

    document.querySelectorAll('.wishlist-count-badge, [data-sc-wish-count]').forEach(function (c) {
      c.textContent = count;
      c.setAttribute('data-count', count);
      c.style.display = 'inline-flex';
      c.style.opacity = '1';
      c.style.visibility = 'visible';
    });

    document.querySelectorAll('[data-sc-wish], .card-wish').forEach(function (t) {
      var id = t.getAttribute('data-sc-wish');
      var pUrl = t.closest('wishlist-button') ? t.closest('wishlist-button').getAttribute('data-product-url') : '';
      var on = wl.has(id) || (pUrl && wl.has(pUrl));
      t.classList.toggle('is-on', on);
      t.classList.toggle('active', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var container = scope.querySelector('wishlist-container');
    if (container && typeof container.setContent === 'function') {
      container.setCountBadges();
      container.setContent();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { SC.syncWishlistUI(document); });
  } else {
    SC.syncWishlistUI(document);
  }
  window.addEventListener('load', function () { SC.syncWishlistUI(document); });
  document.addEventListener('sc:wishlist:change', function () { SC.syncWishlistUI(document); });

  /* ── Product Card Quick Actions (Add to Cart & Buy Now) ─────────────────── */
  document.addEventListener('click', async function (e) {
    var atcBtn = e.target.closest('[data-sc-atc]');
    var buyBtn = e.target.closest('[data-sc-buy]');
    var btn = atcBtn || buyBtn;
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-sc-atc') || btn.getAttribute('data-sc-buy');
    if (!variantId) return;

    var isBuyNow = !!buyBtn;

    btn.setAttribute('disabled', 'true');
    btn.style.opacity = '0.7';

    try {
      var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_add_url)
        ? window.Shopify.routes.cart_add_url + '.js'
        : '/cart/add.js';

      var bodyData = {
        id: variantId,
        quantity: 1,
        sections: ['cart-count-badge', 'offcanvas-cart']
      };

      var res = await fetch(cartUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bodyData)
      });

      var data = await res.json();

      if (res.ok) {
        if (isBuyNow) {
          window.location.href = '/checkout';
          return;
        }

        var ktCart = document.querySelector('kt-cart');
        if (ktCart && typeof ktCart.reloadCartElements === 'function') {
          ktCart.reloadCartElements(data.sections);
        } else if (data.sections) {
          for (var sId in data.sections) {
            var newDoc = new DOMParser().parseFromString(data.sections[sId], 'text/html');
            if (sId === 'cart-count-badge') {
              document.querySelectorAll('.cart-count-badge').forEach(function (badge) {
                var newBadge = newDoc.querySelector('.cart-count-badge');
                if (newBadge) badge.replaceWith(newBadge);
              });
            } else if (sId === 'offcanvas-cart') {
              document.querySelectorAll('.cart-container').forEach(function (container) {
                var newContainer = newDoc.querySelector('.cart-container');
                if (newContainer) container.replaceWith(newContainer);
              });
            }
          }
        }

        var cartOffcanvas = document.getElementById('offcanvas-cart');
        if (cartOffcanvas && window.bootstrap && window.bootstrap.Offcanvas) {
          var bsOffcanvas = window.bootstrap.Offcanvas.getOrCreateInstance(cartOffcanvas);
          bsOffcanvas.show();
        }
      } else {
        alert(data.description || 'Could not add product to cart.');
      }
    } catch (err) {
      console.error('Error adding to cart:', err);
    } finally {
      btn.removeAttribute('disabled');
      btn.style.opacity = '';
    }
  });

  /* ── FBT Bundle Quick Add ───────────────────────────────────────────────── */
  document.addEventListener('click', async function (e) {
    var fbtBtn = e.target.closest('[data-sc-fbt-add]');
    if (!fbtBtn) return;

    e.preventDefault();
    e.stopPropagation();

    var rawIds = fbtBtn.getAttribute('data-sc-fbt-add');
    if (!rawIds) return;

    var variantIds = rawIds.split(',').map(function (id) { return id.trim(); }).filter(Boolean);
    if (!variantIds.length) return;

    fbtBtn.setAttribute('disabled', 'true');
    fbtBtn.style.opacity = '0.7';

    try {
      var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_add_url)
        ? window.Shopify.routes.cart_add_url + '.js'
        : '/cart/add.js';

      var itemsData = variantIds.map(function (vId) {
        return { id: vId, quantity: 1 };
      });

      var bodyData = {
        items: itemsData,
        sections: ['cart-count-badge', 'offcanvas-cart']
      };

      var res = await fetch(cartUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bodyData)
      });

      var data = await res.json();

      if (res.ok) {
        var ktCart = document.querySelector('kt-cart');
        if (ktCart && typeof ktCart.reloadCartElements === 'function') {
          ktCart.reloadCartElements(data.sections);
        } else if (data.sections) {
          for (var sId in data.sections) {
            var newDoc = new DOMParser().parseFromString(data.sections[sId], 'text/html');
            if (sId === 'cart-count-badge') {
              document.querySelectorAll('.cart-count-badge').forEach(function (badge) {
                var newBadge = newDoc.querySelector('.cart-count-badge');
                if (newBadge) badge.replaceWith(newBadge);
              });
            } else if (sId === 'offcanvas-cart') {
              document.querySelectorAll('.cart-container').forEach(function (container) {
                var newContainer = newDoc.querySelector('.cart-container');
                if (newContainer) container.replaceWith(newContainer);
              });
            }
          }
        }

        var cartOffcanvas = document.getElementById('offcanvas-cart');
        if (cartOffcanvas && window.bootstrap && window.bootstrap.Offcanvas) {
          var bsOffcanvas = window.bootstrap.Offcanvas.getOrCreateInstance(cartOffcanvas);
          bsOffcanvas.show();
        }
      } else {
        alert(data.description || 'Could not add bundle to cart.');
      }
    } catch (err) {
      console.error('Error adding bundle to cart:', err);
    } finally {
      fbtBtn.removeAttribute('disabled');
      fbtBtn.style.opacity = '';
    }
  });

  /* ── boot + re-init on theme-editor section load ───────────────────────── */
  function boot(root) {
    SC.initReveal(root);
    SC.initCountdowns(root);
    SC.syncWishlistUI(root);
  }
  if (document.readyState !== 'loading') boot(document);
  else document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
